// src/services/authService.js
import axios from "axios";
import { Auth } from "./authService";

const authController = new Auth();
const { BACKEND_URL } = require("../config/config");

export function obtenerHistorialRequisito(
  idRequisito,
  limit,
  page,
  orderByField,
  orderByDirection) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/expedienteRequisitoHistorico/${idRequisito}?limit=${limit}&page=${page}&orderByField=${orderByField}&orderByDirection=${orderByDirection}`;
  return axios.get(url, {
    headers: {
      Authorization: token,
    },
  });
}
